// DataTables 3 CJS builds expect window.DataTable for styling/plugins.
window.DataTable = require('datatables.net')
require('datatables.net-bs5')
require('datatables.net-buttons')
require('datatables.net-buttons-bs5')
require('datatables.net-buttons/js/buttons.colVis.js')
require('datatables.net-select')
require('datatables.net-select-bs5')
require('../../../public/vendor/datatables/buttons.server-side.js')

const DataTable = window.DataTable

// Register jQuery plugin so yajra's $("#…").DataTable() still works.
DataTable.use(window.jQuery)

const jsonAjaxHeaders = {
	Accept: 'application/json, text/javascript, */*; q=0.01',
	'X-Requested-With': 'XMLHttpRequest',
}

// DT3 uses native XHR without jQuery's Accept header. Yajra only returns JSON when
// Request::ajax() && Request::wantsJson(), so Accept must advertise JSON.
DataTable.ajax.defaults.headers = Object.assign({}, DataTable.ajax.defaults.headers, jsonAjaxHeaders)

$.fn.dataTable.Buttons.defaults.dom.button.className = 'btn btn-sm btn-outline-primary'

const tableDefaults = {
	// Put headers on the table ajax config itself (survives option merge).
	ajax: {
		headers: jsonAjaxHeaders,
	},
	// Prefer DT3 layout over legacy dom so info stays left and paging right (ms-helpdesk look).
	layout: {
		topStart: 'buttons',
		topEnd: 'search',
		bottomStart: 'info',
		bottomEnd: 'paging',
	},
	autoWidth: false,
	pagingType: 'full_numbers',
	pageLength: 10,
	language: {
		processing: '<div class="spinner-border text-primary" role="status"></div>',
		paginate: {
			first: '<i class="ti ti-chevrons-left"></i>',
			previous: '<i class="ti ti-chevron-left"></i>',
			next: '<i class="ti ti-chevron-right"></i>',
			last: '<i class="ti ti-chevrons-right"></i>',
		},
	},
	initComplete: function () {
		console.log('DT Loaded')
	},
}

// Deep-merge so bootstrap renderer layout classes stay intact.
$.extend(true, DataTable.defaults, tableDefaults)
$.extend(true, $.fn.dataTable.defaults, tableDefaults)
